// Fonction pour obtenir le code de locale complet
export const getLocale = (lang) => {
  switch(lang?.toLowerCase()) {
    case 'en': return 'en-US';
    case 'fr': return 'fr-FR';
    case 'he': return 'he-IL';
    default: return 'fr-FR';
  }
};

// Options de formatage de l'heure communes
export const getTimeFormatOptions = (language) => ({
  hour: '2-digit',
  minute: '2-digit',
  hour12: language === 'en',
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
});

// Formater l'heure à partir d'une chaîne de date
export const formatTime = (dateString, language) => {
  return new Date(dateString).toLocaleTimeString(getLocale(language), getTimeFormatOptions(language));
};

// Formater l'heure du shiur
export const formatShiurTime = (time, endTime) => {
  const formattedTime = time.substring(0, 5);
  const formattedEndTime = endTime && endTime !== "00:00:00" 
    ? ` / ${endTime.substring(0, 5)}`
    : "";
  return `${formattedTime}${formattedEndTime}`;
};

// Formater une heure ISO en format HH:MM
export const formatTimeFromISO = (isoString, language) => {
  const date = new Date(isoString);
  return date.toLocaleTimeString(getLocale(language), getTimeFormatOptions(language));
};

// Ajuster une heure avec un offset en minutes
export const adjustTime = (timeString, offsetMinutes, language) => {
  const [hours, minutes] = timeString.split(':');
  const date = new Date();
  date.setHours(parseInt(hours));
  date.setMinutes(parseInt(minutes));
  date.setMinutes(date.getMinutes() + offsetMinutes);
  
  return date.toLocaleTimeString(getLocale(language), getTimeFormatOptions(language));
};

// Formater une heure au format HH:MM
export const formatTimeToHHMM = (timeString, language) => {
  if (!timeString) return '';
  
  // Si c'est déjà au format HH:MM
  if (timeString.length === 5) return timeString;
  
  // Si c'est au format HH:MM:SS
  if (timeString.includes(':')) {
    return timeString.substring(0, 5);
  }
  
  // Pour tout autre format, créer une date et la formater
  const date = new Date(`2000-01-01T${timeString}`);
  return date.toLocaleTimeString(getLocale(language), {
    hour: '2-digit',
    minute: '2-digit',
    hour12: language === 'en'
  });
};

// Arrondir une heure aux 5 minutes les plus proches
export const roundToNearest5Minutes = (timeString) => {
  const [hours, minutes] = timeString.split(':').map(Number);
  const totalMinutes = hours * 60 + minutes;
  const roundedMinutes = Math.round(totalMinutes / 5) * 5;
  
  const newHours = Math.floor(roundedMinutes / 60);
  const newMinutes = roundedMinutes % 60;
  
  return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
}; 